import { css as _css } from "@emotion/react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { forwardRef } from 'react';
import { theme } from '@arc/frontend/ui-theme';
import { LineClamp } from './LineClamp';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "s0legl",
  styles: "display:flex;align-items:center;max-width:100%"
} : {
  name: "nqsb33-IconWithText",
  styles: "display:flex;align-items:center;max-width:100%;label:IconWithText;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
// eslint-disable-next-line @typescript-eslint/no-shadow
export const IconWithText = forwardRef(function IconWithText({
  Icon,
  text,
  link,
  lines = 2,
  ...forwardedProps
}, forwardedRef) {
  return <div ref={forwardedRef} css={_ref}>
			<a target={link ?? '_blank'} rel={link ?? 'noreferrer noopener'} href={link} css={/*#__PURE__*/_css({
      marginTop: '0.1em',
      color: link === undefined ? theme.colors.text.secondary : theme.colors.palettes.primary.main,
      marginRight: '0.5rem'
    }, process.env.NODE_ENV === "production" ? "" : ";label:IconWithText;")}>
				<Icon css={/*#__PURE__*/_css({
        color: theme.colors.text.secondary
      }, process.env.NODE_ENV === "production" ? "" : ";label:IconWithText;")} height={18} width={18} />
			</a>
			<LineClamp css={/*#__PURE__*/_css({
      color: theme.colors.text.primary,
      fontSize: '0.875rem',
      overflowWrap: 'break-word'
    }, process.env.NODE_ENV === "production" ? "" : ";label:IconWithText;")} lines={lines} {...forwardedProps}>
				{text}
			</LineClamp>
		</div>;
});